import React from 'react';
import { TruckIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const CarSelectionStep = ({ cars, selectedCar, onSelect }) => {
  return (
    <div className="space-y-3">
      {cars && cars.length > 0 ? (
        cars.map((car) => (
          <button
            key={car.id}
            onClick={() => onSelect(car)}
            className={`w-full p-4 rounded-lg border-2  text-left ${
              selectedCar?.id === car.id
                ? 'border-purple-600 bg-purple-50 dark:bg-purple-900/20'
                : 'border-gray-300 dark:border-gray-600 hover:border-purple-400 dark:hover:border-purple-500 bg-white dark:bg-gray-800'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${
                  selectedCar?.id === car.id
                    ? 'bg-purple-100 dark:bg-purple-900/30'
                    : 'bg-gray-100 dark:bg-gray-700'
                }`}>
                  <TruckIcon className={`h-6 w-6 ${
                    selectedCar?.id === car.id
                      ? 'text-purple-600 dark:text-purple-400'
                      : 'text-gray-600 dark:text-gray-400'
                  }`} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white">
                    {car.make} {car.model}
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {car.plate} • {car.year || 'N/A'}
                  </p>
                </div>
              </div>
              {selectedCar?.id === car.id && (
                <CheckCircleIcon className="h-6 w-6 text-purple-600 dark:text-purple-400" />
              )}
            </div>
          </button>
        ))
      ) : (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          <TruckIcon className="h-10 w-10 mx-auto text-gray-400 dark:text-gray-500 mb-2" />
          <p>Nu ai vehicule adăugate.</p>
          <p className="text-sm mt-1">Adaugă un vehicul pentru a continua.</p>
        </div>
      )}
    </div>
  );
};

export default CarSelectionStep;
